/* global Swiper, swiperDefaultParams: false */

export default class SwiperSlider {
	constructor(swiperEl) {
		if (!swiperEl) return;

		let swiperElementParams;
		if (swiperEl.dataset.swiperOptions && swiperEl.dataset.swiperOptions.trim().length !== 0) {
			swiperElementParams = JSON.parse(swiperEl.dataset.swiperOptions);
		}

		const swiperParams = {
			resizeReInit: true,
			autoplay: swiperDefaultParams.autoplay && swiperDefaultParams.autoplay.delay ? { delay: Number(swiperDefaultParams.autoplay.delay) } : false,
			slidesPerView: swiperDefaultParams.slidesPerView ? swiperDefaultParams.slidesPerView : 1,
			spaceBetween: swiperDefaultParams.spaceBetween ? swiperDefaultParams.spaceBetween : 0,
			speed: swiperDefaultParams.speed ? Number(swiperDefaultParams.speed) : 300,
			...swiperElementParams
		};

		new Swiper(swiperEl, swiperParams);
	}
}

Array.from(document.querySelectorAll('.swiper')).map(el => new SwiperSlider(el));
